module.exports = __webpack_public_path__ + "img/51.7.Chla.a1aace84.png";